import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MedicalGuide } from '../../models/api';
import { AppState } from '../../models/state';
import { ApiService } from '../../services/api.service';
import { NavService } from '../../services/nav.service';
import { StateService } from '../../services/state.service';
import { UiService } from '../../services/ui.service';

@Component({
  selector: 'app-download-pdf-link',
  templateUrl: './download-pdf-link.component.html',
  styleUrls: ['./download-pdf-link.component.scss']
})
export class DownloadPDFLinkComponent implements OnInit {

  subs: Subscription;
  state: Partial<AppState>;
  buttonText: string;

  constructor(
    private stateService: StateService,
    private ui: UiService,
    private nav: NavService,
    private api: ApiService,
  ) {
    this.subs = new Subscription();
    this.state = this.stateService.getStateValue();
  }

  ngOnInit(): void {
    this.subs.add(
      this.stateService.getState().subscribe(state => { 
        this.state = state;
        this.setButtonText();
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  onClick() {
    if(this.state.searchEngineType === 'additional-services') {
      this.api.downloadAdditionalServicesPdf();
      return;
    }
    if (!this.state?.userIdentified) {
      this.nav.navTo('descargar-guia-medica');
      return;
    }
   this.openDownloadMedicaGuideModal()
  }

  getMedicalGuide(): MedicalGuide {
    // Devolvemos el codigo de guia del state directamente en la peticion.
    let medicalGuide = this.state.medicalGuides.find(ele => ele.codigoGuiaMedica === this.state.codGuia); 
    if(!medicalGuide) medicalGuide = { caracteristicas: [], codigoGuiaMedica: this.state.codGuia, codigoProductoGenerico: '', descripcionComercial: '', descripcionGuiaMedica: '', descripcionProductoGenerico: '', importe: '' };
    return medicalGuide;
  }

  private openDownloadMedicaGuideModal() {
    const data = this.getMedicalGuide();
    if (this.state?.provinces?.length > 0) {
      this.ui.openDownloadMedicaGuideModal(data);
      return;
    }

    this.api.getProvinces().subscribe(provinces => {
      this.state.provinces = provinces;
      this.stateService.updateState(this.state);
      this.ui.openDownloadMedicaGuideModal(data);
    });
  }

  private setButtonText() {
    this.buttonText = this.state.userIdentified || this.state.searchEngineType === 'additional-services'
    ? 'BUTTONS.DOWNLOAD_PDF'
    : 'BUTTONS.I_WANT_TO_BE_A_CUSTOMER';
  }
}
